<template>
  <app-panel>
    <b-row
      class="panel-header"
      slot="panel-header"
      @click="setMetadata.timingStepVisible = !setMetadata.timingStepVisible"
    >
      <b-col>
        <label>{{ $t('sensors.regulation-sets.timing-step') }}</label>
      </b-col>
      <b-col cols="auto">
        <s-collapse-expand-button :value="setMetadata.timingStepVisible"/>
      </b-col>
    </b-row>
    <b-collapse
      id="timingStepCollapse"
      slot="panel-body"
      :visible="setMetadata.timingStepVisible"
    >
      <b-container fluid>
        <b-row
          align-h="around"
          :key="timingStep.number"
          v-for="timingStep in setMetadata.set.timingSteps"
        >
          <b-col
            lg="4"
            xs="12"
            order="0"
          >
            <b-row>
              <b-col
                class="text-center text-lg-right"
                lg="auto"
                xs="6"
                cols="12"
              >
                <label> {{ getDeviationLabel(timingStep) }}</label>
              </b-col>
              <b-col
                lg="auto"
                xs="6"
                cols="12"
                class="text-center text-lg-left"
              >
                <span v-text="timingStep.deviation" />
              </b-col>
            </b-row>
          </b-col>
          <b-col
            lg="4"
            xs="12"
            order="1"
          >
            <b-row class="text-center">
              <b-col
                class="text-center text-lg-right"
                lg="auto"
                xs="6"
              >
                <label v-text="getTimeToUpLabel(timingStep)" />
              </b-col>
              <b-col
                class="text-center text-xs-left"
                lg="auto"
                xs="6"
              >
                <span v-text="timingStep.timeToUp" />
              </b-col>
            </b-row>
          </b-col>
          <b-col
            lg="4"
            xs="12"
            order="2"
          >
            <b-row
              class="
                justify-content-lg-end
                justify-content-center
              "
              align-h="start"
            >
              <b-col
                class="text-center text-lg-right"
                xs="6"
                lg="9"
              >
                <label v-text="getTimeToDownLabel(timingStep)" />
              </b-col>
              <b-col
                class="text-center text-lg-left text-nowrap"
                xs="6"
                lg="3"
              >
                <span v-text="timingStep.timeToDown" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>
  </app-panel>
</template>

<script>
export default {
  props: {
    setMetadata: Object,
  },
  methods: {
    getTimeToUpLabel(timingStep) {
      return this.$t('sensors.regulation-sets.time-to-up', {
        number: timingStep.number,
      });
    },
    getTimeToDownLabel(timingStep) {
      return this.$t('sensors.regulation-sets.time-to-down', {
        number: timingStep.number,
      });
    },
    getDeviationLabel(timingStep) {
      return this.$t('sensors.regulation-sets.deviation', {
        number: timingStep.number,
      });
    },
  },
};
</script>
<style scoped lang="sass">
.panel-header
  &:hover
    cursor: pointer
  &__wrapper
    page-break-inside: avoid

</style>
